// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1j8jL","header":"MessagesList_header__3Wdvz","chat":"MessagesList_chat__3CQAO"};